import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import {
  Identifiable,
  Planzone,
  ResourcesListingConfiguration,
} from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  configuration: ResourcesListingConfiguration;
  retrieveResourcesListingConfiguration(
    req: Boundaries["retrieveResourcesListingConfiguration"]["request"],
  ): void;
}

function useRetrieveResourcesListingConfiguration(
  planzone: Identifiable<Planzone>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveResourcesListingConfigurationRequestPending(planzone),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveResourcesListingConfigurationRequestSuccess(planzone),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveResourcesListingConfigurationRequestFailure(planzone),
    ),
    configuration: useSelector(() =>
      selector.getResourcesListingConfiguration(planzone),
    ),
    retrieveResourcesListingConfiguration:
      core.retrieveResourcesListingConfiguration,
  };
}

export { useRetrieveResourcesListingConfiguration };
